import AccountFormCard from "./AccountFormCard";
import AccountFormName from "./AccountFormName";
import Button from "app/components/UI/Button";
import Flex from "app/components/UI/Flex";
import Icon from "app/components/UI/Icon";
import PropTypes from "prop-types";
import React from "react";
import classes from "./AccountForm.module.css";

export const AccountForm = ({
  translate,
  translateHtml,
  onFieldChange,
  formValue,
  noCardIdentification,
  onSwitchForm,
  isFetching
}) => (
  <div className={classes.accountFormContainer}>
    <div className={classes.accountForm__table}>
      <div className={classes.accountForm__table__header}>
        {translate("Veuillez vous identifier afin de créditer votre compte")}
      </div>
      <div className={classes.accountForm__table__content}>
        {noCardIdentification ? (
          <div>
            <Flex direction="row" middle className={classes.accountForm__info}>
              <Icon className={classes.accountForm__info__icon}>info_outline</Icon>
              <div>
                {translateHtml(
                  "Vous n’avez pas votre numéro d’identification ? <br/> Veuillez entrer votre nom et prénom dans les champs ci-dessous pour retrouver votre compte"
                )}
              </div>
            </Flex>
            <AccountFormName translate={translate} onFieldChange={onFieldChange} formValue={formValue} />
          </div>
        ) : (
          <AccountFormCard translate={translate} onFieldChange={onFieldChange} formValue={formValue} />
        )}
        <Flex direction="row" space="around" wrap>
          <Button
            disabled={isFetching || !Object.keys(formValue).length}
            className={classes.accountForm__submit}
            type="submit"
            secondary
            label={translate("Vérifier le compte")}
          />
          <Button
            className={classes.accountForm__action}
            onClick={onSwitchForm}
            label={
              noCardIdentification ? translate("J'ai un numéro de carte") : translate("Je n'ai pas de numéro de carte")
            }
          />
        </Flex>
      </div>
    </div>
  </div>
);

AccountForm.propTypes = {
  translate: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  formValue: PropTypes.object.isRequired,
  noCardIdentification: PropTypes.bool,
  isFetching: PropTypes.bool,
  onSwitchForm: PropTypes.func
};

export default AccountForm;



// WEBPACK FOOTER //
// ./src/app/components/CheckoutAccount/AccountForm/AccountForm.js